import Vue from 'vue';
import Vuex from 'vuex';
import login from './login'
import uniqid from 'uniqid'
import { mutations, queries } from './graphql'
import { formatDate } from './functions'
Vue.use(Vuex);

const state = {
  auth: {
    authenticated: false,
  },
  me: undefined,
  subaccounts: {
    child: undefined,
    relatives: [],
    friends: [],
    invitedFriends: [],
    caregivers: [],
    invitedCaregivers: [],
  },
  appointments: [],
  notifications: [],
  messages: {
    errors: [],
    warnings: [],
    notices: [],
    announcements: []
  },
  threads: [],
  badges: [],
  unseenBadges: [],
  unseenNotificationsCount: 0
}
export default new Vuex.Store({
  state,
  mutations: {
    SET_ME (state, { me }) {
      Vue.set(state, 'appointments', me.appointments)
      delete me.appointments

      me.notif_sms = JSON.parse(me.notif_sms)
      me.notif_mail = JSON.parse(me.notif_mail)
      Vue.set(state, 'me', me);
      Vue.set(state.auth, 'authenticated', true)
      Vue.set(state, 'messages', {
        errors: [],
        warnings: [],
        notices: [],
        announcements: []
      })
    },
    SET_FAMILY (state, { families }) {
      let family = families[0]
      if (!family) {
        return
      }
      Vue.set(state.me, 'mainFamilyId', family.id)

      if (family.relatives) {
        let relatives = family.relatives
        if (state.me.account_type === 'relative') {
          relatives = relatives.filter(r => r.id !== state.me.id)
        }
        if (state.me.account_type !== 'parent') {
          let mainAccount = family.parents[0]
          relatives = relatives.concat([mainAccount])
        }
        Vue.set(state.subaccounts, 'relatives', relatives)
      }

      if (family.children && state.me.account_type !== 'child') {
        let child = family.children[0]
        Vue.set(state.subaccounts, 'child', child)
      }

      if (family.caregivers) {
        let caregivers = family.caregivers
        Vue.set(state.subaccounts, 'caregivers', caregivers)
      }

      if (family.invitedCaregivers) {
        let invitedCaregivers = family.invitedCaregivers
        Vue.set(state.subaccounts, 'invitedCaregivers', invitedCaregivers)
      }

      if (family.friends) {
        let friends = family.friends
        Vue.set(state.subaccounts, 'friends', friends)
      }

      if (family.invitedCaregivers) {
        let invitedFriends = family.invitedFriends
        Vue.set(state.subaccounts, 'invitedFriends', invitedFriends)
      }
    },
    SET_CHILDREN (state, { families }) {
      let children = families.map((f) => {
        let child = f.children[0]
        child.mainFamilyId = f.id
        child.can = f.can
        child.status = f.status
        child.families = [{
          relatives: f.relatives,
          caregivers: f.caregivers,
          friends: f.friends,
          mainAccount: f.parents[0]
        }]

        return child
      })
      for(let child of children) {
        child.notifications = child.notifications
          .map(n => {
            n.variables = JSON.parse(n.variables)
            return n
          })
          .sort((a, b) => {
          if (a.date === b.date) return 0;
          if (a.date < b.date) return -1;
          if (a.date > b.date) return 1;
        })

      }
      Vue.set(state.subaccounts, 'children', families.map((f)=>f.children[0]))
    },
    UPDATE_GAMES (state, { families }) {
      let family = families[0]
      if (!family) {
        return
      }
      let child = families[0].children[0]
      if (!child) {
        return
      }
      Vue.set(state.me, 'games', child.games)
    },
    UPDATE_NOTIFICATIONS (state, {notifications, unseenNotificationsCount}) {
      notifications = notifications
        .map(n => {
          n.variables = JSON.parse(n.variables)
          return n
        })
        .sort((a, b) => {
        if (a.date === b.date) return 0;
        if (a.date < b.date) return -1;
        if (a.date > b.date) return 1;
      })

      Vue.set(state, 'notifications', notifications)

      if (unseenNotificationsCount) {
        let unseenBadges = notifications.slice(notifications.length - unseenNotificationsCount).filter(n => n.notification_type.indexOf("badge_") === 0).map(b => b.notification_type.slice(6))
        Vue.set(state, 'unseenBadges', unseenBadges)
        if (unseenBadges.length) {
          Vue.set(state, 'unseenNotificationsCount', unseenNotificationsCount - unseenBadges.length)
        } else {
          Vue.set(state, 'unseenNotificationsCount', unseenNotificationsCount)
        }
      }
    },
    UPDATE_ME (state, me ) {
      Vue.set(state, 'me', Object.assign({}, state.me, me))
    },
    REMOVE_AUTH (state) {
      Vue.set(state.auth, 'authenticated', false)
      Vue.delete(state, 'me')
      Vue.set(state, 'subaccounts', { child: undefined, relatives: [] })
      Vue.set(state, 'appointments', [])
      Vue.set(state, 'notifications', [])
      Vue.set(state, 'messages', [])
      Vue.set(state, 'notifications', [])
      Vue.set(state, 'messages', {
        errors: [],
        warnings: [],
        notices: [],
        announcements: []
      })
      Vue.set(state, 'threads', [])
      Vue.set(state, 'badges', [])
      Vue.set(state, 'unseenBadges', [])
    },
    AUTO_EVALUATION (state) {
      Vue.set(state.me, 'already_evaluated', true);
    },
    CREATE_SUBUSER (state, user) {
      if (user.account_type === "child") {
        state.subaccounts.child = user
      } else if (user.account_type === "relative") {
        user.rights = []
        state.subaccounts.relatives.push(user)
      }
    },
    DELETE_SUBUSER (state, userId) {
      let relativeIndex = state.subaccounts.relatives.findIndex(r => r.id === userId)
      Vue.delete(state.subaccounts.relatives, relativeIndex)
    },
    INIT_THREADS (state, threads) {
      Vue.set(state, 'threads', threads.filter(thread => thread.user))
    },
    UPDATE_THREADS (state, threadsUpdates) {
      if (!threadsUpdates) {
        return
      }
      let threads = state.threads.map((oldThread) => {
        let newThread = threadsUpdates.find((t) => t.id === oldThread.id) || {}
        return {...oldThread, ...newThread}
      })
      Vue.set(state, 'threads', threads)
    },
    ADD_MESSAGE_TO_THREAD (state, { threadId, message }) {
      let thread = state.threads.find(_thread => _thread.id === threadId)
      thread.messages.push(message)
    },
    UPDATE_SUBUSER (state, user) {
      if (user.account_type === "child") {
        state.subaccounts.child = Object.assign({}, state.subaccounts.child, user)
      } else if (user.account_type === "relative") {
        let index = state.subaccounts.relatives.findIndex(r => r.id)
        if (index === -1)
          return

        state.subaccounts.relatives[index] = Object.assign({}, state.subaccounts.relatives[index], user)
      }
    },
    CREATE_APPOINTMENT (state, appointment) {
      state.appointments.push(appointment)
    },
    RESET_NOTIFICATIONS_COUNT (state) {
      Vue.set(state, 'unseenBadges', [])
      Vue.set(state, 'unseenNotificationsCount', 0)
    },

    ADD_MESSAGE (state, { messageType, message, layout, cta }) {
      state.messages[messageType + 's'].push({ type: messageType, content: message, layout: layout || 'default', cta })
    },
    CLEAR_MESSAGE (state, { messageType }) {
      state.messages[messageType + 's'].shift()
    },

    PLAY_GAME (state, gameId) {
      let gameIndex = state.me.games.findIndex((game) => {
        return game.id === parseInt(gameId);
      })

      Vue.set(state.me.games[gameIndex], 'score', 1)
    },
    FIRST_CONNEXION (state) {
      Vue.set(state.me, 'firstConnexion', false)
    }
  },
  actions: {
    async signup ({ dispatch, commit }, userData ) {
      try {
        let response = await mutations.createUser(userData)
        if(!response.newUser) {
          throw "noUserError"
        }
        await dispatch('signin', { identifier: userData.email, password: userData.password })
      } catch (e) {
        dispatch('addError', {message: 'Le nom d \'utilisateur ou l\'email sont déjà utilisés.'})
        throw e
      }
    },
    async signin ({ commit, dispatch }, { identifier, password } ) {
      try {
        const loginData = await login(identifier, password)

        localStorage.setItem('token', loginData.token)
        localStorage.setItem('role', loginData._)

        await dispatch('refreshInformations')

        // On envoit les message de "bienvennue"
        if (state.me.firstConnexion) {
          if (state.me.account_type === 'parent') {
          } else if (state.me.account_type === 'child') {
            await dispatch('addAnnouncement', { message:
              `Salut ${state.me.first_name}, je suis Globulo, ton compagnon de route sur le chemin vers la guérison.
              Voici ton carnet de bord.`
            })
          }
        }

        if (state.me.account_type === 'child' && !state.me.already_evaluated) {
          await dispatch('addNotice', { layout: 'autoevaluation', message:
            `On est ${ formatDate(new Date().toISOString().slice(0, 19).replace('T', ' ')) }, comment te sens-tu aujourd-hui ?`
          })
        }

        // On envoit un éventuel sondage sur le dashboard ?
        if (state.me.account_type === 'parent' && state.subaccounts.child) {
          if (state.notifications.findIndex(n => n.notification_type === 'general_survey_completed') === -1) {
            await dispatch('addAnnouncement', { layout: 'survey', cta: '/sondage/iT8nsF', message:
              `Répondez à quelques questions et faites gagner un badge à ${ state.subaccounts.child.first_name }.`
            })
          }
        }

      } catch (e) {
        throw(e)
      }
    },
    signout ({ commit }) {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      commit('REMOVE_AUTH');
    },
    async refreshFamily ({ commit, dispatch }) {
      try {
        let response = await queries.myFamily()

        commit('SET_FAMILY', response.me)
      } catch (e) {
        throw(e)
      }
    },
    async refreshChildrenOnMyList ({ commit, dispatch }) {
      try {
        let response = await queries.childrenOnMyList()

        commit('SET_CHILDREN', { families: response.me.families })
      } catch (e) {
        throw(e)
      }
    },
    async refreshNotifications ({ commit, dispatch }) {
      try {
        let response = await queries.myNotifications()

        commit('UPDATE_NOTIFICATIONS', response.me);
      } catch (e) {
        throw(e)
      }
    },
    async checkForUnseenNotifications({ commit, dispatch }) {
      try {
        let response = await queries.checkForUnseenNotifications()

        if (response.me.unseenNotificationsCount > state.unseenNotificationsCount) {
          await dispatch('refreshNotifications')
        }
      } catch (e) {
        throw(e)
      }
    },
    async getFullRelatives ({ commit, dispatch }) {
      try {
        let response = await queries.myRelatives()

        commit('SET_FAMILY', response.me)
      } catch (e) {
        throw(e)
      }
    },
    async getFullChildren ({ commit, dispatch }) {
      try {
        let response = await queries.myChildren()

        commit('SET_FAMILY', response.me)
      } catch (e) {
        throw(e)
      }
    },
    async refreshInformations ({ commit, dispatch }) {
      try {
        const token = localStorage.getItem('token')
        const role = localStorage.getItem('role')
        if (!token || !role) {
          return
        }

        let response = await queries.myProfile()

        commit('SET_ME', response);
        // TODO utiliser le rôle
        if (role === 'caregiver') {
          await dispatch('refreshChildrenOnMyList')
        } else {
          await dispatch('initMessenger')
          await dispatch('refreshNotifications')
          await dispatch('refreshGames')

          if (role === 'parent') {
            await dispatch('getFullRelatives')
          } else {
            await dispatch('refreshFamily')
          }

        }
      } catch (e) {
        console.log('erreur', e)
        throw(e)
      }
    },
    async initMessenger ({ commit, state }) {
      try {
        let response = await queries.myThreads()
        let threads = response.threads
        threads.map(thread => {
          if (thread.users.length > 2) {
            thread.user = "family"
          } else {
            thread.user = thread.users[0].id === state.me.id
              ? thread.users[1]
              : thread.users[0]
          }
          return thread
        })

        commit('INIT_THREADS', threads);
      } catch (e) {
        throw(e)
      }
    },
    async refreshMessenger ({ commit, state }) {
      try {
        let response = await queries.checkUnreadThreads()
        if(response.threads.findIndex(t => t.is_unread) !== -1) {
          commit('UPDATE_THREADS', response.threads);
        }
      } catch (e) {
        throw(e)
      }
    },
    async refreshThreadMessages ({ commit }, { threadId }) {
      try {
        let response = await queries.getMessagesFromThread( threadId )

        commit('UPDATE_THREADS', response.threads);
      } catch (e) {
        throw(e)
      }
    },
    async markThreadAsRead ({ commit }, { threadId }) {
      try {
        let response = await mutations.markThreadAsRead( threadId )

        commit('UPDATE_THREADS', [{ id: threadId, is_unread: false }]);
      } catch (e) {
        throw(e)
      }
    },
    async addMessageToThread ({ commit }, { threadId, message }) {
      try {
        let response = await mutations.newMessage({ threadId, message })

        commit('ADD_MESSAGE_TO_THREAD', { threadId, message: response.newMessage });
      } catch (e) {
        throw(e)
      }
    },
    async refreshGames ({ commit, state }) {
      try {
        let update = await queries.myObjects()
        commit('UPDATE_GAMES', update.me);
      } catch (e) {
        throw(e)
      }
    },
    async updateMe ({ commit }, { userCommit } ) {
      try {
        let response = await mutations.updateMe(userCommit)
        commit('UPDATE_ME', response.updateMe);
      } catch (e) {
        throw(e)
      }
    },
    async seenLibrary ({}) {
      try {
        let response = await mutations.seenLibrary()
      } catch (e) {
        throw(e)
      }
    },
    async uploadAvatar ({ commit }, file) {
      let response = await window.uploadAvatar(state.me.id, file)
      commit('UPDATE_ME', { avatar: response.data })
    },
    async resetAvatar ({ commit }) {
      let response = await mutations.updateMe({avatar: ''})
      commit('UPDATE_ME', { avatar: '' })
    },
    async createChild ({ commit, dispatch }, { user }) {
      try {
        user.account_type = "child"
        let response = await mutations.createSubUser(user)
        commit('CREATE_SUBUSER', response.newSubUser);

        let update = await queries.myObjects()
        commit('UPDATE_GAMES', update.me);
        commit('UPDATE_NOTIFICATIONS', update.me);

        await dispatch('addAnnouncement', { message:
          `Bonjour ${state.me.first_name} ${state.me.last_name}.
          Vous pouvez gérer ici votre carnet de bord et celui de ${ state.subaccounts.child.first_name } pour son accompagnement.
          Pensez également à gérer vos préférences via le menu ci-dessous.`
        })

      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async createRelative ({ commit, dispatch }, { user }) {
      try {
        user.account_type = "relative"
        let response = await mutations.createSubUser(user)
        commit('CREATE_SUBUSER', response.newSubUser);

        let update = await queries.myObjects()
        commit('UPDATE_NOTIFICATIONS', update.me);
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async deleteRelative ({ commit, dispatch }, userId) {
      try {
        let response = await mutations.deleteSubUser(userId)
        commit('DELETE_SUBUSER', userId);
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async deleteMe ({ commit, dispatch }) {
      try {
        let response = await mutations.deleteMe()
        dispatch('signout')
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async updateSub ({ commit, dispatch }, { userCommit }) {
      try {
        let response = await mutations.updateSubUser(userCommit)
        commit('UPDATE_SUBUSER', response.updateSubUser);
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async createAppointment ({ commit, dispatch }, { appointment }) {
      try {
        let response = await mutations.createAppointment(appointment)
        commit('CREATE_APPOINTMENT', response.newAppointment);

        let update = await queries.myObjects()
        commit('UPDATE_GAMES', update.me);
        commit('UPDATE_NOTIFICATIONS', update.me);
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async deleteAppointment ({ commit, dispatch }, { appointment }) {
      try {
        let response = await mutations.deleteAppointment(appointment);

        await dispatch('refreshInformations');

      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async newAutoEvaluation ({ commit, dispatch }, { value, comment }) {
      try {
        let response = await mutations.createAutoEvaluation({ value, comment })
        commit('AUTO_EVALUATION');
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async sendSuggestion ({ commit, dispatch }, fields) {
      try {
        let response = await mutations.sendSuggestion(fields)
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async sendInvitation ({ commit, dispatch }, { role, identifier }) {
      try {
        let response = await mutations.sendInvitation({ role, identifier })
        if (state.me.account_type === 'parent') {
          dispatch('getFullRelatives')
        } else if (state.me.account_type === 'caregiver') {
          dispatch('refreshChildrenOnMyList')
        }
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async sendContact ({ commit, dispatch }, fields) {
      try {
        let response = await mutations.sendContact(fields)
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async sendFilRouge ({ commit, dispatch }, fields) {
      try {
        let response = await mutations.sendFilRouge(fields)
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async sendNewsletter ({ commit, dispatch }, fields) {
      try {
        let response = await mutations.sendNewsletter(fields)
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async sendResetPasswordInstructions ({ commit, dispatch }, fields) {
      try {
        let response = await mutations.sendResetPasswordInstructions(fields)
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async resetPassword ({ commit, dispatch }, fields) {
      try {
        let response = await mutations.resetPassword(fields)
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async resetNotificationsCount ({ commit, dispatch }, fields) {
      try {
        let response = await mutations.resetNotificationsCount()
        commit('RESET_NOTIFICATIONS_COUNT');
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    addError ({ commit }, { message, layout, cta }) {
      commit('ADD_MESSAGE', { messageType: 'error', message, layout, cta })
    },
    addNotice ({ commit }, { message, layout, cta }) {
      commit('ADD_MESSAGE', { messageType: 'notice', message, layout, cta })
    },
    addAnnouncement ({ commit }, { message, layout, cta }) {
      commit('ADD_MESSAGE', { messageType: 'announcement', message, layout, cta })
    },
    addWarning ({ commit }, { message, layout, cta }) {
      commit('ADD_MESSAGE', { messageType: 'warning', message, layout, cta })
    },
    async clearMessage ({ commit }, { messageType }) {
      commit('CLEAR_MESSAGE', { messageType })
    },
    async playGame ({ commit, dispatch }, gameId) {
      try {
        let response = await mutations.playGame({ id: gameId })
        commit('PLAY_GAME', gameId)
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    async setAuthorizations ({ commit, dispatch }, { id, can }) {
      try {
        await mutations.setAuthorizations({ id, can })
        await dispatch('getFullRelatives')
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
    firstConnexion ({ commit, dispatch }) {
      commit('FIRST_CONNEXION');
    },
    async removeFromFamily ({ commit, dispatch }, { familyId, caregiverId }) {
      try {

        if (state.me.account_type === 'caregiver') {
          caregiverId = state.me.id
        }
        else if (state.me.account_type === 'parent') {
          familyId = state.me.mainFamilyId
        }

        await mutations.removeFromFamily({ familyId, caregiverId })

        if (state.me.account_type === 'caregiver') {
          await dispatch('refreshChildrenOnMyList')
        }
        else if (state.me.account_type === 'parent') {
          await dispatch('getFullRelatives')
        }
      } catch (e) {
        dispatch('addError', {message: 'Une erreur  serveur s\'est produite durant l\'opération.'})
        throw(e)
      }
    },
  },
  getters: {
    completeName: state => {
      if(!state.me) {
        return ''
      }
      return `${state.me.first_name} ${state.me.last_name}`
    },
    childName: (state, getters) => {
      if (getters.accountType === 'anonymous') {
        return ''
      } else if (getters.accountType === 'child') {
        return state.me.first_name
      } else {
        return state.subaccounts.child.first_name
      }
    },
    accountType: state => {
      if(!state.me) {
        return 'anonymous'
      }
      return state.me.account_type
    },
    subAccount: (state) => (id) => {
      id = parseInt(id)
      if (state.subaccounts.child.id === id) {
        return state.subaccounts.child
      } else {
        return state.subaccounts.relatives.find(account => account.id === id)
      }
    },
    currentError: state => {
      return state.message.errors[0]
    },
    currentMessage: state => {
      if (state.messages.errors[0]) {
        return state.messages.errors[0]
      } else if (state.messages.warnings[0]) {
        return state.messages.warnings[0]
      } else if (state.messages.notices[0]) {
        return state.messages.notices[0]
      } else if (state.messages.announcements[0]) {
        return state.messages.announcements[0]
      } else {
        return undefined;
      }
    },
    badges: state => {
      let notifications;
      if (state.me.account_type === "child") {
        notifications = state.notifications
      } else {
        notifications = state.subaccounts.child.notifications
      }

      if (notifications) {
        return notifications.filter(n => n.notification_type.indexOf('badge_') === 0 ).map(b => b.notification_type.slice(6))
      } else {
        return []
      }
    }
  }
});
